import { FC, JSX, useEffect, useState } from "react";
import "./ChatToolsList.scss";
import MasterPage from "../../../MasterPage/MasterPage";
import PageBase from "../../../../components/PageBase/PageBase";
import SkeletonTable from "../../../../components/SkeletonTable/SkeletonTable";
import AppPagination from "../../../../components/AppPagination/AppPagination";
import { toast } from "react-toastify";
import DropdownMenuTable from "../../../../components/DropdownMenuTable/DropdownMenuTable";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faCircleCheck,
  faComments,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import moment from "moment";
import { usePaginate } from "../../../../providers/PaginateProvider";
import { useSidebarFilter } from "../../../../providers/SidebarFilterProvider";
import { useChatTools } from "../../../../providers/Chats/ChatToolsProvider";
import { ChatToolModel } from "../../../../models/Chat/ChatTool/ChatToolModel";
import ModalChatToolInsert from "../../../../components/Chats/ChatTools/ModalChatToolInsert/ModalChatToolInsert";
import ModalChatToolArticles from "../../../../components/Chats/ChatTools/ModalChatToolArticles/ModalChatToolArticles";
import ModalChatToolQuestions from "../../../../components/Chats/ChatTools/ModalChatToolQuestions/ModalChatToolQuestions";
import SidebarChatToolFilter from "../../../../components/Chats/ChatTools/SidebarChatToolFilter/SidebarChatToolFilter";

interface ChatToolsListProps {}

const ChatToolsList: FC<ChatToolsListProps> = () => {
  const [showModalInsert, setShowModalInsert] = useState<boolean>(false);
  const [showModalArticles, setShowModalArticles] = useState<boolean>(false);
  const [articlesTool, setArticlesTool] = useState<ChatToolModel | null>(null);
  const [showModalQuestions, setShowModalQuestions] = useState<boolean>(false);
  const [questionsTool, setQuestionsTool] = useState<ChatToolModel | null>(null);

  const {
    pages,
    params,
    setParams,
    isLoading,
    error,
    tools,
    setTool,
    handleList,
    handleDelete,
    handleReactivate,
  } = useChatTools();
  const { handlePaginate } = usePaginate();
  const { showSidebarFilter, setShowSidebarFilter } = useSidebarFilter();

  useEffect(() => {
    setParams({
      ...params,
      page: 1,
      perPage: 10,
      withPaginate: true,
      filter: { only_active: false },
    });
  }, []);

  const handleEdit = (item: ChatToolModel) => {
    setTool(item);
    setShowModalInsert(true);
  };

  const handleOpenArticles = (item: ChatToolModel) => {
    setArticlesTool(item);
    setShowModalArticles(true);
  };

  const handleCloseArticles = () => {
    setShowModalArticles(false);
    setArticlesTool(null);
  };

  const handleOpenQuestions = (item: ChatToolModel) => {
    setQuestionsTool(item);
    setShowModalQuestions(true);
  };

  const handleCloseQuestions = () => {
    setShowModalQuestions(false);
    setQuestionsTool(null);
  };

  const handleCloseModal = () => {
    setShowModalInsert(false);
    setTool(null);
  };

  const handleDeleteChatTool = (item: ChatToolModel) => {
    Swal.fire({
      title: "<strong>Atenção?</strong>",
      html: `<span>Deseja excluir a ferramenta ${item?.name}?</span>`,
      icon: "question",
      confirmButtonText: "Sim, deletar!",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      confirmButtonColor: "var(--primary)",
    }).then(async (x: any) => {
      if (x.isConfirmed) {
        const ret = await handleDelete(item.id || 0).then();
        if (ret) {
          toast.success("Ferramenta inativada com sucesso!");
          handleList();
        } else {
          await Swal.fire(
            "Ops!",
            `Não foi possível inativar a ferramenta.<br>${error}`,
            "error"
          );
        }
      }
    });
  };

  const handleReactivateItem = async (itemId: number) => {
    if (itemId <= 0) return;

    const ret = await handleReactivate(itemId);

    if (ret) {
      toast.success("Ferramenta reativada com sucesso!");
      handleList();
    }
  };

  const renderList = (): JSX.Element => {
    return (
      <>
        {tools?.length > 0 ? (
          <>
            {tools.map((x: ChatToolModel, key: number) => (
              <tr key={x.id} className="text-sm">
                <td className="text-center">{x.id}</td>
                <td className="text-wrap">{x?.name}</td>
                <td className="text-wrap" title={x?.description}>
                  {x?.description && x.description.length > 100
                    ? `${x.description.slice(0, 100)}...`
                    : x?.description}
                </td>
                <td className="text-center">
                  {x?.category_name ?? x?.category?.name ?? "-"}
                </td>
                <td className="text-center">
                  {x?.section_name ?? x?.section?.name ?? "-"}
                </td>
                <td className="text-center">
                  <span
                    className={
                      x?.deleted_at ? "badge bg-danger" : "badge bg-success"
                    }
                  >
                    {x?.deleted_at ? "Inativo" : "Ativo"}
                  </span>
                </td>
                <td className="text-center">
                  {moment(x?.created_at).format("DD/MM/YYYY HH:mm:ss")}
                </td>
                <td className="text-center">
                  <DropdownMenuTable key={key}>
                    {!x?.deleted_at && (
                      <>
                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleEdit(x)}
                        >
                          <FontAwesomeIcon icon={faEdit} className="me-2" />{" "}
                          Editar
                        </Dropdown.Item>

                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleOpenArticles(x)}
                        >
                          <FontAwesomeIcon icon={faBook} className="me-2" />{" "}
                          Artigos vinculados
                        </Dropdown.Item>

                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleOpenQuestions(x)}
                        >
                          <FontAwesomeIcon icon={faComments} className="me-2" />{" "}
                          Perguntas de exemplo
                        </Dropdown.Item>

                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleDeleteChatTool(x)}
                        >
                          <FontAwesomeIcon icon={faTrash} className="me-2" />{" "}
                          Remover
                        </Dropdown.Item>
                      </>
                    )}
                    {x?.deleted_at && (
                      <Dropdown.Item
                        className="border-radius-md py-2"
                        onClick={() => handleReactivateItem(x?.id ?? 0)}
                      >
                        <FontAwesomeIcon icon={faCircleCheck} className="me-2" />
                        Reativar
                      </Dropdown.Item>
                    )}
                  </DropdownMenuTable>
                </td>
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan={8} className="text-center text-sm">
              Não há registros
            </td>
          </tr>
        )}
      </>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        {!isLoading ? (
          <>
            <div className="table-responsive">
              <table className="table table-flush m-0 w-100">
                <thead className="thead-light">
                  <tr>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      #
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Nome
                    </th>
                    <th className="text-uppercase opacity-7 w-25" scope="col">
                      Descrição
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Categoria
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Sessão
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Status
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Data de Cadastro
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Ação
                    </th>
                  </tr>
                </thead>
                <tbody>{renderList()}</tbody>
              </table>
            </div>

            {tools?.length > 0 && (
              <div>
                <nav aria-label="...">
                  <AppPagination
                    pages={pages}
                    handlePaginate={handlePaginate}
                    params={params}
                    setParams={setParams}
                    style={{ backgroundColor: "#fff" }}
                  />
                </nav>
              </div>
            )}
          </>
        ) : (
          <SkeletonTable />
        )}
      </>
    );
  };

  return (
    <MasterPage title="Ferramentas do Chat" icon="fas fa-wrench" footerFixed>
      <div className="ChatToolsList" data-testid="ChatToolsList">
        <PageBase
          title="Ferramentas do Chat"
          subtitle="Gerenciamento das ferramentas (tools) utilizadas pelo chat."
          handleInsert={() => setShowModalInsert(true)}
          handleFilter={() =>
            !!showSidebarFilter
              ? setShowSidebarFilter(false)
              : setShowSidebarFilter(true)
          }
          error={error}
          hasFilter
          useButtonGroup
        >
          {renderContent()}
        </PageBase>

        <ModalChatToolInsert
          show={showModalInsert}
          onClose={() => handleCloseModal()}
        />

        <ModalChatToolArticles
          show={showModalArticles}
          onClose={() => handleCloseArticles()}
          tool={articlesTool}
        />

        <ModalChatToolQuestions
          show={showModalQuestions}
          onClose={() => handleCloseQuestions()}
          tool={questionsTool}
        />
      </div>

      <SidebarChatToolFilter />
    </MasterPage>
  );
};

export default ChatToolsList;